import { useEffect } from 'react';

function usePreloadLazy(
  targetClass: string,
  activeClass: string | string[],
  onActiveCallback: (element: HTMLElement) => void,
  condition = true
) {
  useEffect(() => {
    if (!condition) return;

    const target = document.querySelector(targetClass);
    if (!target) {
      console.error(`Target element not found: ${targetClass}`);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName !== 'class') {
          return;
        }

        const element = mutation.target as HTMLElement;
        const attributeName = element.getAttribute('class');
        const removeSelectorSymbol = /^[\.#]/;

        if (Array.isArray(activeClass)) {
          const activeClassList = activeClass.map((item) =>
            item.replace(removeSelectorSymbol, '')
          );
          const isActive = activeClassList.some((item) =>
            attributeName?.includes(item)
          );
          if (isActive) {
            onActiveCallback(element);
          }
          return;
        }

        const activeClassItem = activeClass.replace(removeSelectorSymbol, '');
        if (attributeName?.includes(activeClassItem)) {
          onActiveCallback(element);
        }
      });
    });

    observer.observe(target, {
      attributes: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [condition]);
}

export default usePreloadLazy;
